export const packageId = 13 as number;
export const packageInfo = 'com.resulta.checka';
export const defaultChannel = 'pick11';
export const brandName = '13';
export const currencyName = 'Rupee';
export const defaultCurrencySymbol = '₹';
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const gameNavigateVersion = 1;
